module.exports = __webpack_public_path__ + "img/home-hero-banner.29524cfb.svg";